var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-svg",class:[
		_vm.fullpage ? 'fullpage' : '',
		_vm.fullHeight ? 'full-height' : '',
		_vm.verticalPadding ? 'vertical-padding' : '',
		_vm.noPadding ? 'no-padding' : '',
		_vm.noPaddingTop ? 'no-padding-top' : '',
		_vm.noPaddingBottom ? 'no-padding-bottom' : '' ],style:({'background': _vm.bgColor, 'padding-bottom': _vm.noPaddingBottom})},[_c('h2',{style:({color: _vm.textColor})},[_vm._v(_vm._s(_vm.text))]),_c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.parallax),expression:"parallax"}],staticClass:"parallax",domProps:{"innerHTML":_vm._s(this.svg)}})])}
var staticRenderFns = []

export { render, staticRenderFns }